<template>
  <div class="content-box">
    <left-column
      :navList="navList"
      title="帮助中心"
      :activeNav="activeNav"
      :getActive="getActive"
      style="padding-right:30px"
    />
    <div class="content-right">
      <ul>
        <li>
          <h3>1.如何在平台注册？</h3>
          <div class="column_register">
            <div>
              <div class="imgItem">
<!--                <img src="../components/img/组 39@2x.png" alt="">-->
              </div>
              <b>快速注册</b>
              <span>校验手机号码完成注册</span>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
              <div class="imgItem">
<!--                <img src="../components/img/组 40@2x.png" alt="">-->
              </div>
              <b>完善资料</b>
              <span>完善信息上传资质材料</span>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
              <div class="imgItem">
<!--                <img src="../components/img/组 46@2x.png" alt="">-->
              </div>
              <b>资料审核</b>
              <span>1-2工作日内完成审核</span>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
              <div class="imgItem">
<!--                <img src="../components/img/组 49@2x.png" alt="">-->
              </div>
              <b>签约</b>
              <span>商务联系签约</span>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
              <div class="imgItem">
<!--                <img src="../components/img/组 50@2x.png" alt="">-->
              </div>
              <b>完成开通</b>
              <span>账号正常使用</span>
            </div>
          </div>
        </li>
        <li>
          <h3>2.平台如何下单？</h3>
          <div class="column_list">
            <div>
<!--              <img src="../components/img/组 17@2x.png" alt="">-->
              <b>填写订单信息</b>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
<!--              <img src="../components/img/组 10@2x.png" alt="">-->
              <b>填写旅客信息</b>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
<!--              <img src="../components/img/组 31@2x.png" alt="">-->
              <b>支付</b>
            </div>
            <i class="el-icon-arrow-right"></i>
            <div>
<!--              <img src="../components/img/组 32@2x.png" alt="">-->
              <b>订单结果反馈</b>
            </div>
          </div>
        </li>
        <li>
          <h3>3.平台如何支付？</h3>
          <p>微信/支付宝、个人/企业网银…等在线支付方式</p>
        </li>
        <li>
          <h3>4.如何使用/出行？</h3>
          <p>机票、酒店、门票等单品类：预订成功 —>平台下载确认单/联系人手机接收短信 ——>旅客出示内容使用 旅游跟团线路：预订成功 —>平台下载确认单、出团通知书 —> 旅客计划出行（出行前由分销商与旅客签订旅游合同） ** 旅客出行必须携带有效身份证件（护照、身份证等）、出入境的有效签证/签注、建议出行前购买旅游保险</p>
        </li>
        <li>
          <h3>5.如何取消订单</h3>
          <p>未支付，可系统取消；支付成功，需要联系客服申请处理</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import LeftColumn from "../components/leftColumn";

export default {
  name: "distributor-FAQ",
  data() {
    return {
      navList: ["常见问题"],
      activeNav: null
    };
  },
  components: { LeftColumn },

  methods: {
    getActive(val) {
      this.activeNav = val;
    }
  },
  created() {
    this.activeNav = this.$route.query.type || 0;
  }
};
</script>
<style lang="less" scoped>
.content-box {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  display: flex;
  color: #333;
  .content-right {
    width: 100%;
    padding-left: 25px;
    border-left: 1px solid #dfdfdf;
    h3 {
      font-size: 17px;
    }
    p {
      font-size: 12px;
      width: 630px;
      line-height: 25px;
      padding: 10px 5px 34px 15px;
    }
    .column_register {
      margin: 42px 0 35px 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 12px;
      .imgItem {
        width: 55px;
        height: 55px;
        margin: auto;
        border-radius: 50%;
        border: 1px solid #237dc9;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 21px;
          height: 23px;
        }
      }
      span {
        display: block;
      }
      b {
        font-weight: bolder;
        display: block;
        padding: 10px 0 5px 0;
      }
      div {
        text-align: center;
      }
      i {
        font-size: 30px;
        color: #d3d3d3;
        transform: translateY(-10px);
      }
    }

    .column_list {
      margin: 42px 0 35px 0;
      padding-right: 120px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        width: 35px;
        height: 35px;
        margin: auto;
        margin-bottom: 10px;
      }
      b {
        font-size: 12px;
      }
      div {
        text-align: center;
      }
      i {
        font-size: 30px;
        color: #d3d3d3;
        transform: translateY(-10px);
      }
    }
  }
}
</style>
